
      <div appMouseHandler [rgX]="1" [rgY]="1" (newValue)="setSaturationLightness($event)" class="saturation-lightness" [style.background-color]="hsl()">
          <app-cursor [position]="cursorPosition"></app-cursor>
      </div>
    